// Associate a crop dialog's cancellation with its output file. Existing upload
// callbacks can pass the file through unchanged without losing cancellation.
const signals = new WeakMap<File, AbortSignal>()
export function bindUploadSignal(file: File, signal: AbortSignal) {
  signals.set(file, signal)
}
export function getUploadSignal(file: File) {
  return signals.get(file)
}
